module.exports = __webpack_public_path__ + "img/logo-pickem.9bc35c5c.png";